import { DataSource } from '@angular/cdk/table'
import { Observable, Subject, Subscription } from 'rxjs'

import { NotificationMessage } from '../notification-message.model'
import { NotificationService } from '../notification.service'
import { UtilityService } from '@core/services/utility.service'
import { SocketService } from '@core/services/socket.service'
import { FeatureFlagService } from '@core/services/feature-flag.service'
import { RealtimeAlertService } from '../realtime-alert.service'
import { io, Socket } from 'socket.io-client'

export class NotificationDataSource extends DataSource<NotificationMessage> {
  private readonly notificationSource = new Subject<NotificationMessage[]>()

  private socket: Socket
  private alertSub?: Subscription

  socketIteration = 1
  socketData: NotificationMessage

  constructor(
    private readonly notificationService: NotificationService,
    private readonly socketService: SocketService,
    private readonly utilityService: UtilityService,
    private readonly featureFlagService: FeatureFlagService,
    private readonly realtimeAlertService: RealtimeAlertService,
  ) {
    super()
  }

  connect(): Observable<NotificationMessage[]> {
    this.initConnection()

    return this.notificationSource.asObservable()
  }

  initConnection() {
    if (this.featureFlagService.realtimeV3) {
      this.alertSub = this.realtimeAlertService.alerts$.subscribe((notification) => {
        this.notificationSource.next([notification])
      })
      return
    }

    const socket = (this.socket = this.socketService.connect('notifications'))

    socket.on('notification', (notification: NotificationMessage) => {
      this.notificationSource.next([notification])
    })
  }

  disconnect(): void {
    if (this.featureFlagService.realtimeV3) {
      this.alertSub?.unsubscribe()
      this.notificationSource.complete()
      return
    }

    this.socket.removeAllListeners()
    this.socket.close()

    this.notificationSource.complete()
  }
}
